import JobMatcher from "@container/job-matcher";
import AuthLayout from "@container/layout/auth";

export default function JobSeekerJobMatche() {
    return (
        <AuthLayout>
            <JobMatcher />
        </AuthLayout>
    );
}
